import React from "react";

import Card from "react-bootstrap/Card";
const OtherLabPublication = (props) => {
  return (
    <div className="row ml-2">
      <Card className="border-dark mx-2 mb-3">
        <a
          className="b-link"
          href={props.publication.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Card.Header>{props.publication.article}</Card.Header>
        </a>
      </Card>
    </div>
  );
};

export default OtherLabPublication;
